import { cohortIdMap } from "../../utils/CommonUtils/constants";

const VALID_COHORT = new Set([1, 2, 3, 4]);

const emptyCounts = () => ({ 1: 0, 2: 0, 3: 0, 4: 0 });

export function formatCwpmDelta(delta) {
  const rounded = Math.round(delta);
  return `${rounded} CWPM`;
}

/**
 * @param {Array<{ student_id: string, name: string, latest: { cohort: number, cwpm: number, assessed: boolean }, previous: { cohort: number, cwpm: number, assessed: boolean } }>} students
 */
export function buildComparativeViewFromStudents(students, totalStudents, t) {
  const eligible = students.filter(
    (s) => s.latest?.assessed && s.previous?.assessed
  );
  const studentsWithBothAssessments = eligible.length;

  const previousCounts = emptyCounts();
  const currentCounts = emptyCounts();

  const movedUp = [];
  const sameCohort = [];
  const regressed = [];

  eligible.forEach((s) => {
    const pc = Number(s.previous.cohort);
    const lc = Number(s.latest.cohort);
    if (!VALID_COHORT.has(pc) || !VALID_COHORT.has(lc)) {
      return;
    }

    previousCounts[pc] += 1;
    currentCounts[lc] += 1;

    const cwpmChange = s.latest.cwpm - s.previous.cwpm;
    const row = {
      student_id: s.student_id,
      name: s.name,
      previousCwpm: s.previous.cwpm,
      currentCwpm: s.latest.cwpm,
      cwpmChange,
      className: cohortIdMap[lc],
    };

    // Accordion placement (a student may appear in none of the three):
    // — Moved up: higher cohort only (latest > previous).
    // — Same cohort: unchanged cohort AND strictly positive CWPM change.
    // — Regressed: lower cohort (latest < previous).
    if (lc > pc) {
      movedUp.push(row);
    } else if (lc < pc) {
      regressed.push(row);
    } else if (cwpmChange > 0) {
      sameCohort.push(row);
    }
  });

  return {
    totalStudents,
    studentsWithBothAssessments,
    previousCounts,
    currentCounts,
    accordions: [
      {
        id: "moved-up",
        variant: "green",
        subline: t("student_moved_up_description"),
        students: movedUp,
      },
      {
        id: "same-cohort",
        variant: "green",
        subline: t("student_same_cohort_description"),
        students: sameCohort,
      },
      {
        id: "regressed",
        variant: "pink",
        subline: t("student_regressed_description"),
        students: regressed,
      },
    ],
  };
}
